import { render, staticRenderFns } from "./ItemWebOptionMappings.vue?vue&type=template&id=2e92d81e&scoped=true"
import script from "./ItemWebOptionMappings.vue?vue&type=script&lang=js"
export * from "./ItemWebOptionMappings.vue?vue&type=script&lang=js"
import style0 from "./ItemWebOptionMappings.vue?vue&type=style&index=0&id=2e92d81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e92d81e",
  null
  
)

export default component.exports